module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-photographer-a7c0efa5eca395b97748b2c908394948.png";